import request from '@/utils/request'

//获取课程考试列表
export function gettestperiodList(params) {
    return request({
        url: '/portal/test-period/get-list',
        method: 'GET',
        params
    })
}